import classNames from 'classnames/bind';
import React from 'react';
import {
  Button, Col, ListGroup, Row,
} from 'react-bootstrap';
import { AnswerAlternatePrice } from '../../../../../../dorian-shared/types/branch/AnswerStep';
import {
  CurrencyPreference,
} from '../../../../../../dorian-shared/types/CurrencyPreference/CurrencyPreference';
import styles from '../Steps.scss';
import { AlternatePriceTooltip } from './AlternatePriceTooltip';
import { AnswerAlternatePriceItem } from './AnswerAlternatePriceItem';

const cs = classNames.bind(styles);

export interface AnswerAlternatePricesProps {
  values: AnswerAlternatePrice[] | undefined;
  onChange: (data: AnswerAlternatePrice[]) => void;
  answerIndex: number;
  activeSteps: string;
  activeStepsFunc: (step: string) => void;
  stepIndex: number;
  show: boolean;
  currencyToggleSettings: CurrencyPreference;
}

export function AnswerAlternatePrices(props: AnswerAlternatePricesProps) {
  const {
    values = [],
    onChange,
    answerIndex,
    activeSteps,
    activeStepsFunc,
    stepIndex,
    show,
    currencyToggleSettings,
  } = props;

  const handleAddPrice = () => {
    const newValue: AnswerAlternatePrice = { achievementId: 0, answerPrice: 0 };
    onChange([...values, newValue]);
  };

  const handleRemovePrice = (index: number) => {
    const newValues = values.filter((_, i) => i !== index);
    onChange(newValues);
  };

  const handlePriceItemChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number,
    field: keyof AnswerAlternatePrice,
  ) => {
    const newValue = [...values];
    newValue[index][field] = event.target.value as any;
    onChange(newValue);
  };

  return (
    <Row
      className={cs('answerStepAdditionalDataContainer', show ? 'd-block' : 'd-none')}
      data-testid="answerAlternatePrices"
    >
      <Col
        md={12}
        className={cs('mx-0 pb-0 pt-2 border-top')}
      >
        <Row>
          <Col sm="auto" className="d-flex align-items-center">
            <h6 style={{ position: 'relative' }}>
              Alternate Prices
              <AlternatePriceTooltip id={`alt_price-tooltip_${stepIndex}_${answerIndex}`} />
            </h6>
          </Col>
          <Col sm="auto">
            <Button size="sm" variant="secondary" className="ml-3" onClick={handleAddPrice}>
              + Add Price
            </Button>
          </Col>
        </Row>
        <ListGroup as="ul" variant="flush" className={cs('my-1', 'mx-1', 'px-0', 'branchesList')}>
          {
              values.map((value, i) => (
                <AnswerAlternatePriceItem
                  key={i}
                  index={i}
                  answerIndex={answerIndex}
                  stepIndex={stepIndex}
                  activeSteps={activeSteps}
                  activeStepsFunc={activeStepsFunc}
                  value={value}
                  onDelete={() => handleRemovePrice(i)}
                  onChange={(e, field) => handlePriceItemChange(e, i, field)}
                  currencyToggleSettings={currencyToggleSettings}
                />
              ))
            }
        </ListGroup>
      </Col>
    </Row>
  );
}
